import { Location } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  NgModel,
  Validators,
  FormArray,
} from "@angular/forms";
import { NavigationExtras, Router } from "@angular/router";
import { User } from "@core/models";
import { CompanyService, NgxToastrService, UserService, UtilsService } from "@core/services";
import {
  NgbDate,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbInputDatepicker,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { AppState } from "app/app.reducer";
import cities from "assets/utils/cities.json";
import hotels from "assets/utils/hotels.json";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { BookedService } from "../../../../core/services/booked.service";
@Component({
  selector: "app-request-custom-hotel",
  templateUrl: "./request-custom-hotel.component.html",
  styleUrls: ["./request-custom-hotel.component.scss"],
})
export class RequestCustomHotelComponent implements OnInit, OnDestroy {
  public get ngbDateParser(): NgbDateParserFormatter {
    return this._ngbDateParser;
  }
  public set ngbDateParser(value: NgbDateParserFormatter) {
    this._ngbDateParser = value;
  }
  @Output() fromDateEmit = new EventEmitter();
  @Output() toDateEmit = new EventEmitter();
  hoveredDate: NgbDateStruct;
  @ViewChild("d1") bookedInput: NgbInputDatepicker;
  @ViewChild("bookedRange") bookedRange: ElementRef;
  @ViewChild(NgModel) datePick: NgModel;
  @Input() isModal?;
  @Input() userUuid?;
  @Input() companyUuid?;
  @Output() closeEvent? = new EventEmitter();
  subscriptions: Subscription[] = [];
  canRequestCustomBooking: boolean;
  canRequestCustomFlight: boolean;
  canRequestCustomTrain: boolean;
  canRequestCustomCar: boolean;
  canRequestCustomAirbnb: boolean;
  authUserUuid = "";
  userImageBase64: string;
  loading = false;
  form: UntypedFormGroup;
  date = new Date();
  bookedUserAccessType: string;
  minDateNgStruct = {
    year: this.date.getFullYear(),
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  maxDateNgStruct = {
    year: this.date.getFullYear() + 20,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  hotelsList = [];
  citiesList = [];
  city = "";
  user: User;
  userAdmin: any;
  userType: string;
  userToBook: string;
  isAdmin: boolean = false;
  isInvalid: boolean = false;
  companyUsers: { name: string; lastname: string; uuid: string }[] = [];
  defaultUser: any;
  filteredUsers: { name: string; lastname: string; uuid: string }[] = [];
  filteredUsersWithoutDefault: { name: string; lastname: string; uuid: string }[] = [];
  canUseTRM: boolean;
  @ViewChildren('input') searchInputs!: QueryList<ElementRef<HTMLInputElement>>;

  constructor(
    private bookedService: BookedService,
    private formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    private ngxToastrService: NgxToastrService,
    private _ngbDateParser: NgbDateParserFormatter,
    private utilsService: UtilsService,
    private userService: UserService,
    private router: Router,
    private modalService: NgbModal,
    private store: Store<AppState>,
    private location: Location,
    private companyService: CompanyService,
  ) {
    this.subscriptions.push(
      this.store.select("auth").subscribe((s: any) => {
        if (s.user.type?.toUpperCase() === "USER") {
          this.userUuid = s.user.uuid;
          this.authUserUuid = s.user.uuid;
        }
        if (s.user && s.user.type?.toUpperCase() !== "USER") {
          this.isAdmin = true;
          this.userAdmin = s.user;
          this.canUseTRM = s.user.type
            ? s.user.plan && s.user.plan.permissions.canUseTRM
            : s.user.user.plan && s.user.user.plan.permissions.canUseTRM;
        }
        this.userToBook = localStorage.getItem("userToBook")
          ? this.utilsService.decrypt(localStorage.getItem("userToBook"))
          : null;
        this.userType = s.user.type;
      })
    );
  }

  ngOnInit() {
    if (
      window.history.state.canRequestCustomBooking !== null &&
      window.history.state.canRequestCustomCar !== null &&
      window.history.state.canRequestCustomFlight !== null &&
      window.history.state.canRequestCustomTrain !== null &&
      window.history.state.canRequestCustomAirbnb !== null
    ) {
      this.canRequestCustomBooking = window.history.state.canRequestCustomBooking;
      this.canRequestCustomCar = window.history.state.canRequestCustomCar;
      this.canRequestCustomFlight = window.history.state.canRequestCustomFlight;
      this.canRequestCustomTrain = window.history.state.canRequestCustomTrain;
      this.canRequestCustomAirbnb = window.history.state.canRequestCustomAirbnb;
      this.userUuid = window.history.state.userUuid;
      this.companyUuid = window.history.state.companyUuid;
      this.userImageBase64 = window.history.state.userImageBase64;
    } else {
      this.router.navigate(["/custom-services"]);
    }
    this.getCompanyUsers();
    if (
      this.userUuid &&
      (this.userUuid !== null || this.userUuid !== undefined)
    ) {
      this.userService
        .getUser(this.userUuid)
        .pipe(take(1))
        .subscribe((user: User) => {
          this.bookedUserAccessType = user.type;
          this.user = user;
          this.defaultUser = {
            name: this.user.name,
            lastname: this.user.lastname,
            uuid: this.user.uuid
          };
          this.form.get("defaultTraveler").setValue([{ 
            uuid: this.defaultUser.uuid, 
            name: this.defaultUser.name, 
            lastname: this.defaultUser.lastname 
          }]);
        });
    }

    this.form = this.formBuilder.group({
      hotel: [null, Validators.required],
      city: [null, [Validators.required]],
      checkIn: [null, [Validators.required]],
      checkOut: [null, [Validators.required]],
      comments: [""],
      rooms: [1, Validators.min(1)],
      userUuid: this.userUuid,
      companyUuid: this.companyUuid,
      defaultTraveler: this.formBuilder.control([], Validators.required),
      travelersPerRoom: this.formBuilder.array([]),
    });

    this.form.get("rooms").valueChanges.subscribe(value => {
      this.updateTravelersPerRoom(value);
    });
  }

  updateTravelersPerRoom(roomCount: number) {
    const travelersArray = this.getTravelersPerRoom;
    const currentValues = travelersArray.value;
    while (travelersArray.length < roomCount - 1) {
      travelersArray.push(this.formBuilder.control([], Validators.required));
    }
    while (travelersArray.length > roomCount - 1) {
      travelersArray.removeAt(travelersArray.length - 1);
    }
    travelersArray.controls.forEach((control, index) => {
      if (currentValues[index]) {
        control.setValue(currentValues[index]);
      }
    });
  }
  
  get getTravelersPerRoom(): FormArray {
    return this.form.get("travelersPerRoom") as FormArray;
  }

  compareUsers(user1: any, user2: any): boolean {
    return user1 && user2 ? user1.uuid === user2.uuid : user1 === user2;
  }

  onSubmit() {
    this.isInvalid = false;
    this.loading = true;
    const body = this.form.getRawValue();
    const allTravelersPerRoom = [
      this.form.get("defaultTraveler")?.value,
      ...this.getTravelersPerRoom?.value
    ];
    const formattedTravelersPerRoom = allTravelersPerRoom.map((room, index) => ({
      roomNumber: index + 1,
      travelers: room
    }));
    body["travelersPerRoom"] = formattedTravelersPerRoom;
    const totalTravelers = body["travelersPerRoom"]
      ? body["travelersPerRoom"].reduce((acc, room) => acc + (room.travelers ? room.travelers.length : 0), 0)
      : 0;

    const formatDate = (ngbDate: NgbDate): string =>
      `${ngbDate.year}-${String(ngbDate.month).padStart(2, '0')}-${String(ngbDate.day).padStart(2, '0')}`;
  
      body["checkIn"] = moment(formatDate(body["checkIn"]))
        .format("DD-MM-YYYY");
  
      body["checkOut"] = moment(formatDate(body["checkOut"]))
        .format("DD-MM-YYYY");
    body[
      "comments"
    ] = `(comments): ${body["comments"]} + (rooms): ${body["rooms"]} + (people): ${totalTravelers}`;

    if (this.user) {
      body["holder"] = { name: this.user.name, surname: this.user.lastname };
    }

    delete body.defaultTraveler
    // delete body.rooms;

    this.subscriptions.push(
      this.bookedService.sendCustomHotelRequest(body).subscribe(
        (s) => {
          this.subscriptions.push(
            this.translate
              .get(["common.congrat", "hotel.custom.request.success"])
              .subscribe((result) => {
                this.loading = false;
                this.ngxToastrService.typeSuccess(
                  result["common.congrat"],
                  result["hotel.custom.request.success"]
                );
                if (this.isModal) {
                  this.closeEvent.emit(s);
                } else {
                  const route = this.utilsService.getNavigationRoute(this.userAdmin || this.user, null, this.canUseTRM);
                  if (route) {
                    this.router.navigate([route]);
                  }
                }
              })
          );
        },
        (err) => {
          this.translate.get("hotel.custom.request..error").subscribe((result) => {
            this.loading = false;
            this.ngxToastrService.typeInfo(result, err.error.message);
          });
        }
      )
    );
  }

  get f() {
    return this.form.controls;
  }

  goBack() {
    this.location.back();
  }

  emitDates() {
    this.fromDateEmit.emit(this.form.controls["checkIn"].value);
    this.toDateEmit.emit(this.form.controls["checkOut"].value);
  }

  onDateSelection(date: NgbDate) {
    const checkIn = this.form.controls["checkIn"].value;
    const checkOut = this.form.controls["checkOut"].value;
  
    if (!checkIn) {
      this.form.controls["checkIn"].setValue(date);
    } else if (date && !checkOut && date.after(checkIn)) {
      this.form.controls["checkOut"].setValue(date);
    } else {
      this.form.controls["checkOut"].setValue(null);
      this.form.controls["checkIn"].setValue(date);
    }
    this.updateDateInput();
  }
  
  onDatepickerClosed() {
    const checkIn = this.form.controls["checkIn"].value;
    const checkOut = this.form.controls["checkOut"].value;
  
    if (checkIn && !checkOut) {
      this.form.controls["checkOut"].setValue(checkIn);
    }
    this.updateDateInput();
  }
  
  updateDateInput() {
    this.bookedRange.nativeElement.value =
      this.ngbDateParser.format(this.form.controls["checkIn"].value) +
      " - " +
      this.ngbDateParser.format(this.form.controls["checkOut"].value);
  
    this.emitDates();
  }

  isHovered(date: NgbDate) {
    return (
      this.form.controls["checkIn"].value &&
      !this.form.controls["checkOut"].value &&
      this.hoveredDate &&
      date.after(this.form.controls["checkIn"].value) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return (
      date.after(this.form.controls["checkIn"].value) &&
      date.before(this.form.controls["checkOut"].value)
    );
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.form.controls["checkIn"].value) ||
      date.equals(this.form.controls["checkOut"].value)
    );
  }

  closeModalCross() {
    this.modalService.dismissAll();
  }

  navigate(route: string) {
    const navigationExtra: NavigationExtras = {
      state: {
        canRequestCustomBooking: this.canRequestCustomBooking,
        canRequestCustomFlight: this.canRequestCustomFlight,
        canRequestCustomTrain: this.canRequestCustomTrain,
        canRequestCustomCar: this.canRequestCustomCar,
        canRequestCustomAirbnb: this.canRequestCustomAirbnb,
        userUuid: this.userUuid ? this.userUuid : this.authUserUuid,
        companyUuid: this.companyUuid,
        userImageBase64: this.userImageBase64,
      },
      queryParams: {
        userId: this.userUuid ? this.userUuid : this.authUserUuid,
        companyUuid: this.companyUuid,
      },
      replaceUrl: true
    };

    this.router.navigate(["custom-services/" + route], navigationExtra);
  }

  // Buscador de ciudades
  getCities(value: string) {
    this.citiesList = [];
    if (value !== "" && value.length > 2) {
      cities.Table1.forEach((v) => {
        if (
          v["name"]?.toLowerCase().includes(value?.toLowerCase()) &&
          !this.citiesList.includes(v["name"])
        ) {
          this.citiesList.push(v["name"]);
        }
      });
    } else {
      this.citiesList = [];
    }
  }
  getHotels(value: string) {
    if (value !== "" && this.city !== "") {
      hotels.hotels.forEach((h) => {
        {
          if (
            h["city"]?.toLowerCase().includes(this.city?.toLowerCase()) &&
            !this.hotelsList.includes(h.name)
          ) {
            this.hotelsList.push(h.name);
          }
        }
      });
    } else {
      this.hotelsList = [];
    }
  }

  getCompanyUsers() {
    this.companyService.getCompanyUsers(this.companyUuid).subscribe(
      (res) => {
        this.companyUsers = res.map(user => ({
          name: user.name,
          lastname: user.lastname,
          uuid: user.uuid
        }));
        this.filteredUsers = [...this.companyUsers];
        this.filteredUsersWithoutDefault = this.filteredUsers.filter(user => user.uuid !== this.defaultUser?.uuid);
      },
      (err) => {}
    );
  }

  isFormValid(): boolean {
    const travelersPerRoom = this.getTravelersPerRoom.value;
    const allRoomsHaveTravelers = travelersPerRoom.every(room => room && room.length > 0);
    return this.form.valid && allRoomsHaveTravelers;
  }

  getOutMinDateManual() {
    return this.utilsService.getOutDate(
      this.minDateNgStruct,
      this.form.controls["checkIn"].value
    );
  }

  cleanCitiesList(option) {
    this.city = option;
    this.citiesList = [];
  }
  cleanHotelsList() {
    this.hotelsList = [];
  }

  applyFilter(filterValue: string) {
    this.filteredUsers = this.companyUsers.filter(user =>
      `${user.name} ${user.lastname}`.toLowerCase().includes(filterValue.toLowerCase())
    );
    this.filteredUsersWithoutDefault = this.companyUsers.filter(user =>
      `${user.name} ${user.lastname}`.toLowerCase().includes(filterValue.toLowerCase())
    );
  }

  clearSearch(index: number) {
    const input = this.searchInputs.toArray()[index];
    if (input) {
      input.nativeElement.value = '';
    }

    this.filteredUsers = [...this.companyUsers];
    this.filteredUsersWithoutDefault = this.filteredUsers.filter(user => user.uuid !== this.defaultUser?.uuid);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
